import { StyledSummaryTableCell, SummaryHeader } from '../../../../components';
import { useFormContext } from 'react-hook-form';
import { useContext } from 'react';
import { Localization } from '../../../../config/localization/localization';
import { LanguageSelectorContext } from '../../../../context/LanguageSelectorContext';

import type { IUpdateVehicleResponse } from '../../../../types';
import type { FC } from 'react';

interface IVehiclesProps {
    setStep: (step: number) => void;
}

export const VehicleSummary: FC<IVehiclesProps> = ({ setStep }) => {
    const formContext = useFormContext();
    const { selectedLanguage } = useContext(LanguageSelectorContext);
    const localization = new Localization(selectedLanguage);

    const vehicles: Array<IUpdateVehicleResponse> = formContext.getValues('allVehicles');

    const onStepClick = () => setStep(4);

    return (
        <div>
            <SummaryHeader isLink onLink={onStepClick}>
                {localization.translate('vehicleSummary.stepLink')}
            </SummaryHeader>

            {/* NO VEHICLES MESSAGE */}
            {vehicles?.length === 0 && (
                <span className={'font-medium dark:text-gray-200'}>
                    {localization.translate('vehicleSummary.noVehiclesMessage')}
                </span>
            )}

            {/* VEHICLE TABLE */}
            {vehicles?.length !== 0 && (
                <table className={'mt-1'}>
                    <thead>
                        <tr>
                            <StyledSummaryTableCell isHeader>
                                {localization.translate('vehicleSummary.nameHeader')}
                            </StyledSummaryTableCell>
                            <StyledSummaryTableCell isHeader isNumeric>
                                {localization.translate('vehicleSummary.regularTimeHeader')}
                            </StyledSummaryTableCell>
                        </tr>
                    </thead>
                    <tbody>
                        {vehicles.map((v) => {
                            return (
                                <tr key={v.itemId}>
                                    <StyledSummaryTableCell>{v.title}</StyledSummaryTableCell>
                                    <StyledSummaryTableCell isNumeric>{v.regular}</StyledSummaryTableCell>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}
        </div>
    );
};